module.exports = __webpack_public_path__ + "img/collection-memoireRingsCheap@2x.b661261.jpg";